import { Component, EventEmitter, Input, Output } from '@angular/core';
import { QueryParamsHandling, Router } from '@angular/router';

@Component({
    selector: 'top-navbar',
    templateUrl: './top-navbar.component.html',
    styleUrls: ['./top-navbar.component.scss'],
    standalone: false
})
export class TopNavbarComponent {
    @Input() backButtonLabel = 'back';
    @Input() backButtonOptionalLabel = '';
    @Input() label!: string;
    @Input() redirectLink = '';
    @Input() showHome = true;
    @Input() queryParamsObj = {};
    @Input() queryParamsHandlingValue: QueryParamsHandling = 'preserve';
    @Input() state = {};
    @Output() clickBack = new EventEmitter();

    constructor(private router: Router) { }

    navigateUserToBackPage () {
        if(this.redirectLink){
            this.router.navigate(['/register/dashboard']);
            this.router.navigate([this.redirectLink],{
                queryParams: this.queryParamsObj,
                queryParamsHandling: this.queryParamsHandlingValue,
            });
        } else {
            this.clickBack.emit();
        }
    }

    navigateUserToHome () {
        this.router.navigate(['/register/dashboard']);
    }
}
